// types
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';

const initialState = require('../initialState').sessionInitialState;

export const login = createAsyncThunk('creadentials/login', (payload) => {
    return API.post('EFWAPI', '/app/user/login', {
        body: payload
    });
});

export const logout = createAsyncThunk('creadentials/logout', (token) => {
    return API.get('EFWAPI', '/app/user/logout', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const register = createAsyncThunk('creadentials/register', (payload) => {
    return API.post('EFWAPI', '/app/user/register', {
        body: payload
    });
});

export const updateData = createAsyncThunk('creadentials/get-user-data', (token) => {
    return API.get('EFWAPI', '/app/user', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

const session = createSlice({
    name: 'session',
    initialState,
    reducers: {
        // logoff: () => {
        //     return initialState;
        // },
        updateAvatar: (state, action) => {
            state.credentials.user.has_avatar = action.payload.has_avatar;
            state.credentials.user.avatar_file = action.payload.avatar_file;
        }
    },
    extraReducers: (builder) => {
        //login
        builder.addCase(login.pending, (state) => {
            state.loading = true;
            state.login.processing = true;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            const response = action.payload;

            if (response?.success) {
                state.loggedIn = true;
                state.credentials.user = response.data.user;
                state.credentials.menu_permissions = response.data?.permissions?.menu ?? [];
                state.credentials.route_permissions = response.data?.permissions?.route ?? [];
                state.credentials.action_permissions = response.data?.permissions?.action ?? [];
                state.credentials.token = response.data.token;
            } else {
                state.login.error = response?.error;
                state.login.failed = true;
            }
            state.loading = false;
            state.login.processing = false;
        });
        builder.addCase(login.rejected, (state) => {
            state.loading = false;
            state.login.failed = true;
            state.login.processing = false;
        });

        //logout
        builder.addCase(logout.pending, (state) => {
            state.loading = true;
            state.logout.processing = true;
        });
        builder.addCase(logout.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success == false) {
                state.logout.error = response?.error;
                state.logout.failed = true;
            }
            state.loggedIn = false;
            state.credentials = initialState.credentials;

            state.loading = false;
            state.logout.processing = false;
        });
        builder.addCase(logout.rejected, (state) => {
            state.loggedIn = false;
            state.credentials = initialState.credentials;

            state.loading = false;
            state.logout.failed = true;
            state.logout.processing = false;
        });

        //register
        builder.addCase(register.pending, (state) => {
            state.loading = true;
            state.register.processing = true;
        });
        builder.addCase(register.fulfilled, (state, action) => {
            const response = action.payload;

            if (response?.success) {
                state.loggedIn = true;
                state.credentials.user = response.data.user;
                state.credentials.token = response.data.token;
            } else {
                state.register.error = response?.error;
                state.register.failed = true;
            }
            state.loading = false;
            state.register.processing = false;
        });
        builder.addCase(register.rejected, (state) => {
            state.loading = false;
            state.register.failed = true;
            state.register.processing = false;
        });
        //updateData
        builder.addCase(updateData.pending, (state) => {
            state.loading = true;
            state.updateData.processing = true;
        });
        builder.addCase(updateData.fulfilled, (state, action) => {
            const response = action.payload;

            if (response?.success) {
                state.credentials.user = response.data.user;
                state.credentials.menu_permissions = response.data?.permissions?.menu ?? [];
                state.credentials.route_permissions = response.data?.permissions?.route ?? [];
                state.credentials.action_permissions = response.data?.permissions?.action ?? [];
            } else {
                state.updateData.error = response?.error;
                state.updateData.failed = true;
            }
            state.loading = false;
            state.updateData.processing = false;
        });
        builder.addCase(updateData.rejected, (state) => {
            state.loading = false;
            state.updateData.failed = true;
            state.updateData.processing = false;
        });
    }
});

export default session.reducer;

export const { updateAvatar } = session.actions;
